import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./List.css";

const Header = () => {
  const [priceList, setPriceList] = useState([]);

  // Fetch documents on component mount
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(
          "https://pricelist.rukmanimfg.com/api/file/getAlldocuments" // Ensure the URL matches the backend route
        );
        if (response.data.success) {
          setPriceList(response.data.documents);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchDocuments();
  }, []);
  return (
    <>
      <div className="container-fluid" style={{ backgroundColor: "#4d8eff" }}>
        <nav className="navbar navbar-expand-lg custom_nav-container">
          <a className="navbar-brand" href="index.html">
            <img src="images/logo.png" alt />
            <span>RMR</span>
          </a>
        </nav>
      </div>

      <section className="price_list_section layout_padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading_container">
                <h2 style={{ color: "#1a2e35" }}>Price List</h2>
              </div>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>File</th>
                    <th style={{ color: "#1a2e35" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {priceList.map((item) => (
                    <tr key={item._id}>
                      <td>{item.document_name}</td>
                      <td>
                        {/* Make the file clickable to view */}
                        <Link
                          to={`https://pricelist.rukmanimfg.com/api/file/view/${item.document}`} // Adjust URL as needed
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {/* Clean file name by removing prefix */}
                          {item.document
                            .split("/")
                            .pop()
                            .split("-")
                            .slice(1)
                            .join("-")}
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`https://pricelist.rukmanimfg.com/api/file/view/${item.document}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-addss addllst"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
